import {
  type Configuration,
  PublicClientApplication,
} from '@azure/msal-browser'

const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID

const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/organizations`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
